import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-6"
}
const _hoisted_4 = {
  key: 1,
  class: "col-6"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = ["value", "placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "row mt-20"
}
const _hoisted_16 = { class: "d-flex align-items-center justify-content-between w-100" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_form_group_read_only_text = _resolveComponent("v-form-group-read-only-text")!
  const _component_v_form_group_input_date = _resolveComponent("v-form-group-input-date")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_form_group_input_checkbox = _resolveComponent("v-form-group-input-checkbox")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    "class-name": "modal-fullscreen-lg-down",
    onKeypress: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.meta.valid ? _ctx.updateCalendarEvent() : null), ["prevent"]), ["enter"]))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Editando evento')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_form_group_input_text, {
              value: _ctx.title,
              label: _ctx.$t('Asunto'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.title,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.title = $event))
            }, null, 8, ["value", "label", "yup-errors-variable"]),
            _createVNode(_component_v_form_group_read_only_text, {
              label: _ctx.$t('Tipo'),
              text: _ctx.consultationType
            }, null, 8, ["label", "text"]),
            _createElementVNode("div", _hoisted_2, [
              (_ctx.isConsultation && _ctx.status === 'loaded')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_v_form_group_read_only_text, {
                      label: _ctx.$t('Paciente'),
                      text: !!_ctx.calendarEvent.patient ? _ctx.calendarEvent.patient.user.name + ' ' +
               _ctx.calendarEvent.patient.user.surname + ' - ' + _ctx.calendarEvent.patient.nif : 'No hay paciente asociado'
                    }, null, 8, ["label", "text"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isConsultation && !_ctx.isVideoconsulta && _ctx.status === 'loaded')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_v_form_group_read_only_text, {
                      label: _ctx.$t('Clínica'),
                      text: !!_ctx.calendarEvent.clinic ? _ctx.calendarEvent.clinic.name +
              ' (' + _ctx.calendarEvent.clinic.address + ')' : 'No hay clínica asociada'
                    }, null, 8, ["label", "text"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_form_group_input_date, {
                  value: _ctx.date,
                  label: _ctx.$t('Fecha'),
                  class: "mb-24",
                  "yup-errors-variable": _ctx.errors.date,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event))
                }, null, 8, ["value", "label", "yup-errors-variable"])
              ]),
              (!_ctx.isAllDayActivated)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Inicio'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.startTime
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.startTime}),
                            options: _ctx.startTimeOptions,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.startTime = $event)),
                            modelValue: _ctx.startTime,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startTime) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Fin'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.endTime
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.endTime}),
                            options: _ctx.endTimeOptions,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.endTime = $event)),
                            modelValue: _ctx.endTime,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endTime) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_v_form_group_input_checkbox, {
                  "for-key": "isAllDayActivated",
                  label: _ctx.$t('Durante todo el día'),
                  value: _ctx.isAllDayActivated,
                  class: "'form-check-inline'",
                  "onUpdate:value": _ctx.handleAllDayActivatedCheckboxClick
                }, null, 8, ["label", "value", "onUpdate:value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('Descripción')), 1),
                _createElementVNode("textarea", {
                  class: "form-control",
                  rows: "5",
                  value: _ctx.description,
                  placeholder: this.$t('Introduce una descripción aquí...'),
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.description = $event.target.value))
                }, null, 40, _hoisted_14)
              ])
            ]),
            (!_ctx.isAuthor)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_v_alert, {
                    variant: "warning",
                    role: "alert"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`Esta ${_ctx.consultationType} ha sido agendada por un administrador. No puedes editarla.`)), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_ctx.patientId && _ctx.isConsultation && _ctx.startTimeChanged)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 1,
                    variant: "primary",
                    role: "alert"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(// eslint-disable-next-line max-len
            _ctx.$t('Al editar la hora de esta "{tipo_consulta}" se mandará un SMS al paciente con la nueva hora indicada.',{ tipo_consulta: _ctx.consultationType })), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            (_ctx.isAuthor)
              ? (_openBlock(), _createBlock(_component_v_button, {
                  key: 0,
                  variant: "danger",
                  class: "me-8",
                  "aria-label": _ctx.$t('Eliminar'),
                  onClick: _ctx.confirmDelete
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Eliminar')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_v_button, {
                variant: "link-secondary",
                class: "me-24",
                "aria-label": _ctx.$t('Cerrar'),
                "data-bs-dismiss": "modal"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Cerrar')), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]),
              (_ctx.isAuthor)
                ? (_openBlock(), _createBlock(_component_v_button, {
                    key: 0,
                    variant: "secondary",
                    "aria-label": _ctx.$t('Guardar cambios'),
                    disabled: !_ctx.meta.valid || _ctx.accepted,
                    "is-loading": _ctx.accepted,
                    onClick: _ctx.updateCalendarEvent
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Guardar cambios')), 1)
                    ]),
                    _: 1
                  }, 8, ["aria-label", "disabled", "is-loading", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}